// extracted by mini-css-extract-plugin
module.exports = {"container":"_8b8b374","title":"_19aac8c","iconWrap":"_9e0150a"};